import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Home from './../components/Home';
import utils from './../lib/utils';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    app: state.app,
    auth: state.auth,
    business: state.business,
    carriers: state.carriers,
    greeting: state.greeting,
    softwares: state.softwares,
    voicemails: state.voicemails,
    conversations:state.conversations,
    dashboard: state.dashboard,
    currentDomain: utils.getCookie('domain'),
    billing: state.billing,
    preferences: state.preferences,

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
